import { MenuItem, Link } from '@mui/material';
import NavLink from '../commons/NavLink';
import styles from './Header.module.css';

interface IProps {
  to: string;
  label: string;
  action?: Function;
}

function HeaderMobileMenuLink({ to, label, action }: IProps) {
  return (
    <MenuItem>
      {action && (
        <Link
          href={to}
          className={styles.mobileMenuLink}
          onClick={(e: React.MouseEvent) => (action ? action(e) : undefined)}
        >
          {label}
        </Link>
      )}
      {!action && (
        <Link
          component={NavLink}
          to={to}
          activeClassName={styles.active}
          className={styles.mobileMenuLink}
        >
          {label}
        </Link>
      )}
    </MenuItem>
  );
}

export default HeaderMobileMenuLink;
